import { afterNextRender, DestroyRef, ElementRef, inject, Signal, signal, WritableSignal } from '@angular/core';

export function injectElementSize(): Signal<DOMRectReadOnly | null> {
    const elementRef: ElementRef<any> = inject(ElementRef);
    const destroyRef: DestroyRef = inject(DestroyRef);
    const size: WritableSignal<DOMRectReadOnly | null> = signal<DOMRectReadOnly | null>(null);

    const observer: ResizeObserver = new ResizeObserver(entries => size.set(entries[0]?.contentRect ?? null));
    afterNextRender(() => observer.observe(elementRef.nativeElement));
    destroyRef.onDestroy(() => observer.disconnect());
    return size.asReadonly();
}
